import { action, computed, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../common/Api";
import { RootStore } from "./Store";
import moment from "moment";
import { RegionFilterStore } from "./RegionFilterStore";

export class FeedbacksStore {
  store: RootStore;

  filterStore: RegionFilterStore;

  loading = false;

  filter: any = {
    page: 0,
    size: 20,
    resolved: false,
    rating: "",
    regionId: "",
    divisionId: "",
    communityId: "",
    period: [undefined, undefined],
  };

  sortedInfo = { columnKey: "createDate", order: "descend" };

  data = {
    total: 0,
    avgRating: 0,
    avgResponseTime: "",
    items: [],
  };

  constructor(store: RootStore) {
    makeAutoObservable(this, {
      store: false,
      pagination: computed,
    });
    this.store = store;
    this.filterStore = new RegionFilterStore(this);
    this.filterStore.periodLabel = "Feedback Time";
  }

  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }

  get ratings() {
    return [
      { id: "", name: "All" },
      { id: "0", name: "-" },
      { id: "1", name: "1" },
      { id: "2", name: "2" },
      { id: "3", name: "3" },
      { id: "4", name: "4" },
      { id: "5", name: "5" },
    ];
  }

  @action onSearch(history) {
    this.onPage(history, 1, this.filter.size);
  }

  @action onPage(history, page, size) {
    let period: any[] = [undefined, undefined];
    if (this.filter.period?.[0]) {
      period = [
        moment(this.filter.period?.[0]).format("YYYY-MM-DD"),
        moment(this.filter.period?.[1]).format("YYYY-MM-DD"),
      ];
    }
    const query = new URLSearchParams({ ...this.filter, period, page: page - 1, size });
    history.push({ search: query.toString() });
  }

  @action onLocation(location) {
    const params = new URLSearchParams(location.search);
    const resolved = params.get("resolved") === "true";
    const regionId = params.get("regionId") || "";
    const divisionId = params.get("divisionId") || "";
    const communityId = params.get("communityId") || "";
    const page = parseInt(params.get("page") || "0");
    const size = parseInt(params.get("size") || "20");
    const rating = params.get("rating") || "";

    const periodStr = params.get("period") || ",";
    const period = periodStr !== "," ? periodStr.split(",").map((x) => moment(x)) : [undefined, undefined];
    console.log("p", period);
    this.filter = { resolved, rating, regionId, divisionId, communityId, period, page, size };

    this.refresh();
  }

  @action
  refresh() {
    this.loading = true;
    const { rating, regionId, divisionId, communityId, period, resolved, page, size } = this.filter;

    const sorts = this.sortedInfo.order
      ? [{ field: this.sortedInfo.columnKey, order: this.sortedInfo.order === "descend" ? "desc" : "asc" }]
      : [];

    const filter: any = {
      regionId,
      divisionId,
      communityId,
      resolved,
      page,
      size,
      sorts,
    };
    if (rating !== "") {
      filter.rating = parseInt(rating);
    }
    if (period?.[0]) {
      filter.period = [moment(period[0]).startOf("day").toISOString(), moment(period[1]).endOf("day").toISOString()];
    }
    return Api.feedback
      .feedbacks(filter)
      .then((res) => {
        runInAction(() => {
          this.data = res.data.feedbacks;
        });
      })
      .finally(() =>
        runInAction(() => {
          this.loading = false;
        })
      );
  }
}
